import Vue from "vue";
import { INotificationOnClickResult, Notification } from "./notification";
import { SaleService } from "@/services";
import { Sale } from "../base";

export class PublicSaleNotification extends Notification {
	public async onClick(vue: Vue): Promise<INotificationOnClickResult> {
		let s = new Sale({ID: this.Data.SaleID});
		let url = await SaleService.generatePublicUrl(s);
		window.open(url,"_blank");
		return {closeNotificationModal: true};
	}

	public getIcon():string {
		return "signature";
	}

	public getTone():string {
		return "success";
	}

	public getActionKey():string {
		return "open-document";
	}
}
